{
  "zh-TW": {
    "browser-not-supported.title": "瀏覽器不受支援",
    "browser-not-supported.view-supported": "檢視支援的瀏覽器"
  },
  "zh-CN": {
    "browser-not-supported.title": "浏览器不受支持",
    "browser-not-supported.view-supported": "查看支持的浏览器"
  },
  "tr-TR": {
    "browser-not-supported.title": "Tarayıcı desteklenmiyor",
    "browser-not-supported.view-supported": "Desteklenen tarayıcıları göster"
  },
  "sv-SE": {
    "browser-not-supported.title": "Webbläsaren stöds inte",
    "browser-not-supported.view-supported": "Visa webbläsare som stöds"
  },
  "sk-SK": {
    "browser-not-supported.title": "Browser not supported",
    "browser-not-supported.view-supported": "View supported browsers"
  },
  "ru-RU": {
    "browser-not-supported.title": "Браузер не поддерживается",
    "browser-not-supported.view-supported": "Просмотр поддерживаемых браузеров"
  },
  "ro-RO": {
    "browser-not-supported.title": "Browser not supported",
    "browser-not-supported.view-supported": "View supported browsers"
  },
  "pt-PT": {
    "browser-not-supported.title": "Browser not supported",
    "browser-not-supported.view-supported": "View supported browsers"
  },
  "pt-BR": {
    "browser-not-supported.title": "Navegador não compatível",
    "browser-not-supported.view-supported": "Ver navegadores compatíveis"
  },
  "pl-PL": {
    "browser-not-supported.title": "Przeglądarka nieobsługiwana",
    "browser-not-supported.view-supported": "Wyświetl obsługiwane przeglądarki"
  },
  "no-NO": {
    "browser-not-supported.title": "Nettleser støttes ikke",
    "browser-not-supported.view-supported": "Vis støttede nettlesere"
  },
  "nl-NL": {
    "browser-not-supported.title": "Browser wordt niet ondersteund",
    "browser-not-supported.view-supported": "Ondersteunde browsers bekijken"
  },
  "ko-KR": {
    "browser-not-supported.title": "지원되지 않는 브라우저",
    "browser-not-supported.view-supported": "지원되는 브라우저 보기"
  },
  "ja-JP": {
    "browser-not-supported.title": "サポートされていないブラウザーです",
    "browser-not-supported.view-supported": "サポートされているブラウザーを表示"
  },
  "it-IT": {
    "browser-not-supported.title": "Browser non supportato",
    "browser-not-supported.view-supported": "Visualizza i browser supportati"
  },
  "is-IS": {
    "browser-not-supported.title": "Browser not supported",
    "browser-not-supported.view-supported": "View supported browsers"
  },
  "hu-HU": {
    "browser-not-supported.title": "Nem támogatott böngésző",
    "browser-not-supported.view-supported": "Támogatott böngészők megtekintése"
  },
  "fr-FR": {
    "browser-not-supported.title": "Navigateur non pris en charge",
    "browser-not-supported.view-supported": "Afficher les navigateurs pris en charge"
  },
  "fi-FI": {
    "browser-not-supported.title": "Selainta ei tueta",
    "browser-not-supported.view-supported": "Näytä tuetut selaimet"
  },
  "et-EE": {
    "browser-not-supported.title": "Browser not supported",
    "browser-not-supported.view-supported": "View supported browsers"
  },
  "es-ES": {
    "browser-not-supported.title": "Navegador incompatible",
    "browser-not-supported.view-supported": "Ver navegadores compatibles"
  },
  "en-ZZ": {
    "browser-not-supported.title": "⁣⁢Browser not supported⁪⁮⁮؜‌⁫⁬؜⁮⁫⁯⁠⁪⁪‍⁯؜⁪⁡⁬⁡؜‍⁣⁤",
    "browser-not-supported.view-supported": "⁣⁢View supported browsers؜‌⁠⁯⁬⁠؜⁠‌‌⁬⁬⁬⁡⁯⁠⁮⁬⁡⁠‌⁠⁯⁣⁤"
  },
  "en-US": {
    "browser-not-supported.title": "Browser not supported",
    "browser-not-supported.view-supported": "View supported browsers"
  },
  "en-GB": {
    "browser-not-supported.title": "Browser not supported",
    "browser-not-supported.view-supported": "View supported browsers"
  },
  "de-DE": {
    "browser-not-supported.title": "Browser nicht unterstützt",
    "browser-not-supported.view-supported": "Unterstützte Browser anzeigen"
  },
  "da-DK": {
    "browser-not-supported.title": "Browser understøttes ikke",
    "browser-not-supported.view-supported": "Se understøttede browsere"
  },
  "cs-CZ": {
    "browser-not-supported.title": "Prohlížeč není podporován",
    "browser-not-supported.view-supported": "Zobrazit podporované prohlížeče"
  }
}